"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const alert = {
    MuiAlert: {
        styleOverrides: {
            root: {
                backgroundColor: colors_1.default.white[600],
                color: colors_1.default.text[100],
                border: "thin",
                borderStyle: "solid",
                borderRadius: "1rem",
            },
            standardInfo: {
                borderColor: colors_1.default.info,
                ".MuiSvgIcon-root": { color: colors_1.default.info },
            },
            standardSuccess: {
                borderColor: colors_1.default.success,
                ".MuiSvgIcon-root": { color: colors_1.default.success },
            },
            standardError: {
                borderColor: colors_1.default.error,
                ".MuiSvgIcon-root": { color: colors_1.default.white[900] },
            },
            standardWarning: {
                borderColor: colors_1.default.warning,
                ".MuiSvgIcon-root": { color: colors_1.default.warning },
            },
        },
    },
};
exports.default = alert;
